import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RejectModalComponent } from './reject-modal/reject-modal.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { CustomerFeedbackComponent } from './customer-feedback/customer-feedback.component';
import { HeaderModule } from 'src/app/shared/header/header.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { Select2Module } from 'ng-select2-component';
import { ApproveModalComponent } from './approve-modal/approve-modal.component';
import { UnapproveModalComponent } from './unapprove-modal/unapprove-modal.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomerNewConnectionsComponent } from './customer-detail/new-connections/customer-new-connections.component';
import { Tier2ApproveModalComponent } from './tier2-approve-modal/tier2-approve-modal.component';
import { UserMetricsComponent } from './user-metrics/user-metrics.component';
import { LeastValuableMembersComponent } from './least-valuable-members/least-valuable-members.component';

@NgModule({
  declarations: [
    CustomerListComponent,
    CustomerDetailComponent,
    CustomerFeedbackComponent,
    RejectModalComponent,
    ApproveModalComponent,
    UnapproveModalComponent,
    CustomerNewConnectionsComponent,
    Tier2ApproveModalComponent,
    UserMetricsComponent,
    LeastValuableMembersComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HeaderModule,
    NgxPaginationModule,
    AppRoutingModule,
    Select2Module,
    SharedModule,
  ],
})
export class CustomerModule {}
